export const PASSWORD_MIN_LENGTH = 8;

export const evaluarPassword = (password = '') => {
  const value = String(password || '');

  const checks = {
    length: value.length >= PASSWORD_MIN_LENGTH,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    symbol: /[^A-Za-z0-9]/.test(value),
  };

  const score = Object.values(checks).filter(Boolean).length;

  let strength = {
    label: 'Sin completar',
    className: 'is-empty',
  };

  if (value) {
    if (score <= 2) {
      strength = {
        label: 'Débil',
        className: 'is-weak',
      };
    } else if (score === 3) {
      strength = {
        label: 'Media',
        className: 'is-medium',
      };
    } else if (score === 4) {
      strength = {
        label: 'Buena',
        className: 'is-good',
      };
    } else {
      strength = {
        label: 'Fuerte',
        className: 'is-strong',
      };
    }
  }

  return {
    checks,
    score,
    strength,
    isValid: score === Object.keys(checks).length,
  };
};

export const validarNuevaPassword = (
  password = '',
  confirmPassword = ''
) => {
  const { checks, isValid } = evaluarPassword(password);

  if (!checks.length) {
    return `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres.`;
  }

  if (!isValid) {
    return 'La contraseña debe incluir mayúscula, minúscula, número y símbolo.';
  }

  if (password !== confirmPassword) {
    return 'Las contraseñas no coinciden.';
  }

  return null;
};
